(function () {
  var MOBILE_MAX = 1023;
  var CONTENT_GAP = 20;
  var SCROLL_DELTA = 10;
  var TOP_EXPAND = 40;
  var BOTTOM_LOCK = 60;

  function relocateFeaturesNav() {
    var featuresNav = document.querySelector('.features-nav');
    var header = document.querySelector('[data-site-header]');
    var featuresLayout = document.querySelector('.features-layout');
    if (!featuresNav || !header || !featuresLayout) return;

    if (window.innerWidth <= MOBILE_MAX) {
      if (featuresNav.parentElement !== header) {
        header.appendChild(featuresNav);
        featuresNav.setAttribute('data-features-nav-moved', '');
      }
      return;
    }

    if (featuresNav.hasAttribute('data-features-nav-moved')) {
      featuresLayout.insertBefore(featuresNav, featuresLayout.firstChild);
      featuresNav.removeAttribute('data-features-nav-moved');
    }
  }

  function updateStickyTop() {
    var root = document.documentElement;

    if (window.innerWidth > MOBILE_MAX) {
      root.style.removeProperty('--sticky-top');
      return;
    }

    var header = document.querySelector('[data-site-header]');
    var bottom = 0;
    var nav = document.querySelector('.site-header__nav');
    if (nav) {
      bottom = Math.max(bottom, nav.getBoundingClientRect().bottom);
    }

    var featuresNav = document.querySelector('.features-nav');
    if (
      featuresNav &&
      header &&
      header.contains(featuresNav) &&
      !header.classList.contains('is-nav-collapsed')
    ) {
      bottom = Math.max(bottom, featuresNav.getBoundingClientRect().bottom);
    }

    root.style.setProperty('--sticky-top', Math.ceil(bottom + CONTENT_GAP) + 'px');
  }

  function updateMobileContentOffset() {
    var root = document.documentElement;
    var main = document.getElementById('MainContent');
    var logo = document.querySelector('.site-header__logo svg, .site-header__logo img');
    var header = document.querySelector('[data-site-header]');
    var wasCollapsed = header && header.classList.contains('is-nav-collapsed');

    // Measure expanded nav height so collapse doesn't shrink page padding
    // (keeps bottom logo clearance and avoids content jumping under the logo).
    if (wasCollapsed) {
      header.classList.remove('is-nav-collapsed');
    }

    relocateFeaturesNav();

    if (window.innerWidth > MOBILE_MAX) {
      root.style.removeProperty('--content-offset');
      root.style.removeProperty('--main-top');
      root.style.removeProperty('--header-logo-height');
      root.style.removeProperty('--sticky-top');
      if (wasCollapsed && header) {
        header.classList.add('is-nav-collapsed');
      }
      return;
    }

    if (logo) {
      var logoH = logo.getBoundingClientRect().height;
      root.style.setProperty(
        '--header-logo-height',
        Math.max(100, logoH) + 'px'
      );
    } else {
      root.style.setProperty('--header-logo-height', '100px');
    }

    if (!main || document.body.classList.contains('template-index')) {
      root.style.removeProperty('--content-offset');
      root.style.removeProperty('--main-top');
      if (wasCollapsed && header) {
        header.classList.add('is-nav-collapsed');
      }
      updateStickyTop();
      return;
    }

    var headerEnd = 0;
    var nav = document.querySelector('.site-header__nav');
    if (nav) {
      headerEnd = Math.max(headerEnd, nav.getBoundingClientRect().bottom);
    }

    var featuresNav = document.querySelector('.features-nav');
    if (featuresNav && header && header.contains(featuresNav)) {
      headerEnd = Math.max(headerEnd, featuresNav.getBoundingClientRect().bottom);
    }

    // Layout offset only — getBoundingClientRect().top changes with scroll and
    // inflates --content-offset when load/fonts.ready/resize fire after scrolling.
    var mainTop = main.offsetTop;
    var offset = Math.max(0, headerEnd + CONTENT_GAP - mainTop);

    root.style.setProperty('--content-offset', offset + 'px');
    root.style.setProperty('--main-top', mainTop + 'px');

    if (wasCollapsed && header) {
      header.classList.add('is-nav-collapsed');
    }

    updateStickyTop();
  }

  function initDisclosure(header) {
    if (!header.hasAttribute('data-header-disclosure')) return;

    var openBtns = header.querySelectorAll('[data-header-open-sub]');
    if (!openBtns.length) return;

    function getPanel(key) {
      return document.querySelector('.site-sub-nav__row[data-sub-panel="' + key + '"]');
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-header-open-sub');
        var panel = getPanel(key);
        if (!panel) return;
        var first = panel.querySelector('a[href]');
        if (first) {
          window.location.assign(first.href);
        }
      });
    });
  }

  function setNavCollapsed(header, collapsed) {
    if (!header) return;
    var wasCollapsed = header.classList.contains('is-nav-collapsed');
    if (collapsed === wasCollapsed) return;

    if (collapsed) {
      header.classList.add('is-nav-collapsed');
    } else {
      header.classList.remove('is-nav-collapsed');
    }
    // Do not recalc --content-offset / --header-logo-height here:
    // collapsing the nav must not shrink page padding or content will
    // slide under the fixed bottom logo. Sticky attach point still updates.
    updateStickyTop();
  }

  function initScrollCollapse(header) {
    var toggle = header.querySelector('[data-menu-toggle]');
    if (!toggle) return;

    var lastY = window.scrollY || 0;
    var ticking = false;

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX;
    }

    function onScroll() {
      if (!isMobile()) return;

      var y = window.scrollY || 0;
      var delta = y - lastY;
      var maxY = Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
      var nearBottom = y >= maxY - BOTTOM_LOCK;

      if (y <= TOP_EXPAND) {
        setNavCollapsed(header, false);
        lastY = y;
        return;
      }

      if (Math.abs(delta) < SCROLL_DELTA) return;

      if (delta > 0) {
        setNavCollapsed(header, true);
      } else if (!nearBottom) {
        // Ignore upward deltas at the page bottom (overscroll / bounce)
        // so the menu doesn't expand without an intentional scroll up.
        setNavCollapsed(header, false);
      }

      lastY = y;
    }

    function onScrollRaf() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
    }

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      setNavCollapsed(header, false);
    });

    window.addEventListener('scroll', onScrollRaf, { passive: true });
    window.addEventListener('resize', function () {
      lastY = window.scrollY || 0;
      if (!isMobile()) {
        setNavCollapsed(header, false);
      }
    });
  }

  function init() {
    var header = document.querySelector('[data-site-header]');
    if (header) {
      initDisclosure(header);
      initScrollCollapse(header);
    }

    updateMobileContentOffset();

    window.addEventListener('resize', updateMobileContentOffset);
    window.addEventListener('load', updateMobileContentOffset);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateMobileContentOffset);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
